// src/components/CardList.js
import React from 'react';
import Card from './Card';
import './CardList.css';

function CardList({ cards, addCardToDeck, deck, showCardDetails }) {
    return (
      <ul className="card-list">
        {cards.map((card) => {
          const isInDeck = deck.some(deckCard => deckCard.card_id === card.card_id);
          return (
            <Card
              key={card.card_id}
              card={card}
              addCardToDeck={addCardToDeck}
              isInDeck={isInDeck}
              showCardDetails={showCardDetails}  // 詳細表示の関数を渡す
            />
          );
        })}
      </ul>
    );
  }

export default CardList;